import { useNavigation, useRoute } from '@react-navigation/native'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { Box, Heading } from 'native-base'
import { useEffect, useRef, useState } from 'react'
import { useDesktopBreakpoint } from '../../../../domain/services/useBreakpoint'
import { useCabanaApi } from '../../providers/CabanaApiProvider'
import { GuestScreenParams } from '../../screens/GuestScreen'
import FormAccessoryNavigation from '../_shared/form/FormAccessoryNavigation'
import ChooseLoginMethod, { LoginMethod } from './ChooseLoginMethod'
import EnterEmail from './EnterEmail'
import MagicLinkLogin from './MagicLinkLogin'
import PasswordLogin from './PasswordLogin'
import ResetPassword from './ResetPassword'

enum FormState {
  ENTER_EMAIL,
  CHOOSE_LOGIN_METHOD,
  MAGIC_LINK_LOGIN,
  PASSWORD_LOGIN,
  RESET_PASSWORD,
}

const LoginForm = () => {
  const navigation =
    useNavigation<NativeStackNavigationProp<GuestScreenParams>>()
  const route = useRoute()
  const { AuthPasswordlessApi } = useCabanaApi()
  const [email, setEmail] = useState('')
  const referralCode = route.params?.referralCode
  const inputRefs = [useRef(), useRef()]
  const focusedInput = useRef(0)
  const isDesktop = useDesktopBreakpoint()

  const [state, setState] = useState(FormState.ENTER_EMAIL)
  const [stateComponent, setStateComponent] = useState(<></>)

  const [loginMethods, setLoginMethods] = useState([])
  useEffect(() => {
    if (state === FormState.ENTER_EMAIL)
      setStateComponent(<EnterEmail callback={onEmailEntered} />)
    else if (state === FormState.CHOOSE_LOGIN_METHOD)
      setStateComponent(
        <ChooseLoginMethod
          methods={loginMethods}
          callback={onLoginMethodChosen}
        />
      )
    else if (state === FormState.MAGIC_LINK_LOGIN)
      setStateComponent(<MagicLinkLogin email={email} />)
    else if (state === FormState.PASSWORD_LOGIN)
      setStateComponent(
        <PasswordLogin email={email} onResetPassword={onResetPassword} />
      )
    else if (state === FormState.RESET_PASSWORD)
      setStateComponent(<ResetPassword email={email} />)
    else setStateComponent(<Heading pt="100px">Uhhh...{state}</Heading>)
  }, [state])

  const onEmailEntered = (email) => {
    setEmail(email)
    return AuthPasswordlessApi.lookupAccount(email).then((response) => {
      if (response.data.exists) {
        setLoginMethods(response.data.loginMethods)
        setState(FormState.CHOOSE_LOGIN_METHOD)
      } else navigation.navigate('Signup', { email, referralCode })
    })
  }

  const onLoginMethodChosen = (method) => {
    if (method === LoginMethod.MAGIC_LINK) setState(FormState.MAGIC_LINK_LOGIN)
    else if (method === LoginMethod.PASSWORD) setState(FormState.PASSWORD_LOGIN)
  }

  const onResetPassword = () => {
    setState(FormState.RESET_PASSWORD)
  }

  return (
    <>
      {!isDesktop && (
        <Box mt={-4} mx={-6} borderTopWidth={1} borderTopColor="muted.50" />
      )}
      {stateComponent}
      <FormAccessoryNavigation
        inputRefs={inputRefs}
        focusedInput={focusedInput}
      />
    </>
  )
}

export default LoginForm
